// Copyright ©️ 2026 eVolve MEP, LLC

import { type Shipment, type ShipmentItem, useEvolveDelete } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';

import type { ModalRegistryManagedProps } from 'components/Mantine/Modals/createModalRegistry';
import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';

type Props = ModalRegistryManagedProps & {
  shipment: Shipment;
  deleteItem: ShipmentItem;
  onItemDeleted: () => void;
};

export const RemoveItemModal = ({ shipment, deleteItem, onItemDeleted, ...props }: Props) => {
  const { apiCall: deleteShipmentItemApiCall } = useEvolveDelete('shop/shipment/:shipmentId/item/:shipmentItemId');

  return (
    <WrappedModal
      title="Remove item from shipment"
      onConfirm={async () => {
        await deleteShipmentItemApiCall({
          url: `shop/shipment/${shipment.shipmentId}/item/${deleteItem.shipmentItemId}`,
        });
        onItemDeleted();
      }}
      buttonColor="red"
      confirmationText="Remove"
      {...props}
    >
      <Text>
        Remove <b>{deleteItem.workOrderItemName}</b> from shipping order <b>{shipment.name}</b>?
      </Text>
    </WrappedModal>
  );
};
